import { API_BASE } from '../config';

export const startInteractiveSession = async (url: string, proxy?: { host: string; port: string; user: string; password: string }, workflowId?: string): Promise<{ sessionId: string; url: string; vncUrl: string }> => {
    const res = await fetch(`${API_BASE}/interactive/start`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ url, proxy, workflowId }),
    });
    if (!res.ok) throw new Error('Failed to start interactive session');
    return res.json();
};

export const stopInteractiveSession = async (sessionId: string): Promise<void> => {
    await fetch(`${API_BASE}/interactive/${sessionId}/stop`, { method: 'POST' });
};

export const enablePickMode = async (sessionId: string, parentLocator?: { method: string; value: string } | null, multi?: boolean): Promise<void> => {
    await fetch(`${API_BASE}/interactive/${sessionId}/pick/enable`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ parentLocator: parentLocator || null, multi: !!multi }),
    });
};

export const disablePickMode = async (sessionId: string): Promise<void> => {
    await fetch(`${API_BASE}/interactive/${sessionId}/pick/disable`, { method: 'POST' });
};

export const enablePickModeSilent = async (sessionId: string, parentLocator?: { method: string; value: string; index?: number } | null): Promise<void> => {
    await fetch(`${API_BASE}/interactive/${sessionId}/pick/enable-silent`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ parentLocator: parentLocator || null }),
    });
};

export const disablePickModeSilent = async (sessionId: string): Promise<void> => {
    await fetch(`${API_BASE}/interactive/${sessionId}/pick/disable-silent`, { method: 'POST' });
};

export const getPickResult = async (sessionId: string): Promise<any> => {
    const res = await fetch(`${API_BASE}/interactive/${sessionId}/pick/result`);
    const data = await res.json();
    return data.result;
};

export const playActionInSession = async (sessionId: string, action: any): Promise<{ success: boolean; message: string }> => {
    const res = await fetch(`${API_BASE}/interactive/${sessionId}/play`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action }),
    });
    if (!res.ok) throw new Error('Failed to play action');
    return res.json();
};

export const captureElementAtCursor = async (sessionId: string): Promise<any> => {
    const res = await fetch(`${API_BASE}/interactive/${sessionId}/pick/capture`, { method: 'POST' });
    const data = await res.json();
    return data.result;
};

export const injectMouseTracker = async (sessionId: string): Promise<void> => {
    await fetch(`${API_BASE}/interactive/${sessionId}/track/mouse`, { method: 'POST' });
};

export const triggerCapture = async (sessionId: string): Promise<any> => {
    const res = await fetch(`${API_BASE}/interactive/${sessionId}/pick/trigger`, { method: 'POST' });
    const data = await res.json();
    return data.result;
};

export const freezeSession = async (sessionId: string): Promise<void> => {
    await fetch(`${API_BASE}/interactive/${sessionId}/freeze`, { method: 'POST' });
};

export const unfreezeSession = async (sessionId: string): Promise<void> => {
    await fetch(`${API_BASE}/interactive/${sessionId}/unfreeze`, { method: 'POST' });
};
